import Vue from 'vue';

const showError = (context, response) => {
    context.abAccount.errorMsg = response.msg;
    toastr.error(response.msg);
}

const success = (context, response) => {
    console.log(response);
    if(response.response_code) {
        switch (response.response_code) {
            case "MFA_SUCCESS":
                const account = JSON.parse(response.account);
                context.airbnbActiveStep = 5;
                context.airbnbUserId = account.airbnb_user_id;
                context.airbnbConnectUpdate();
                return;
            case "MFA_FAILED":
                showError(context, response);
                return;
            case "AIRLOCK_VERIFICATION":
                context.airbnbActiveStep = 1;
                showError(context, response);
                return;
            case "SHOULD_RECONNECT":
                context.airbnbActiveStep = 1;
                context.airbnbConnectUpdate();
        }
    }
};

export default (context) => {
    const [verif_type, method_id] = context.verificationFrictionType.split("-");
    return Vue.$http.post('/airbnb/connect/mfa/verification', {
        airbnb_temp_user_id: context.abAccount.tempId,
        verif_type,
        method_id,
        code: context.airbnbVerificationCode,
    })
    .then(response => {
        if (response && response.status === 200) {
            success(context, response.data);
        } else {
            showError(context, response.data);
        }
    }).catch(error => {
        showError(context, error.response.data);
    });
}


// WEBPACK FOOTER //
// ./src/app/services/airbnb/sendMFACode.js